import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faGear, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import image from './../../assets/pexels/counsel.jpg'
import Heading from './../../components/Heading';

const RemoteService = () => {
  return (
    <section className="py-10">
      <div className="container mx-auto px-5 mt-6">
        <div className="grid md:grid-cols-2 gap-10 items-center">
        <div className="relative min-h-[550px]">
            <img
              className="absolute w-full h-full object-cover rounded-lg"
              src={image}
              alt="Remote"
            />
          </div>
          <div>   
          <Heading name="Remote In-House Counsel" tstyle="mt-2 mb-4"/>
            <p className="mb-4 text-justify">
            At PocketLPO, we provide Remote In-House Counsel Services that act as a seamless extension of your team. Our dynamic,
             cost-effective solutions are tailored to meet the needs of businesses of all sizes, ensuring expert legal support without the overhead of full-ime staff.
            </p>
            <h1 className="uppercase text-lg font-bold my-1">Key Features</h1>
            <div className='mt-6'>
                <h5 className="mb-3 flex items-center font-semibold">
                  <div className="p-4 bg-emerald-600 opacity-90 text-white flex items-center justify-center w-12 h-12 mr-4">
                    <FontAwesomeIcon className="text-xl" icon={faPhoneAlt} />
                  </div>
                  Comprehensive Legal Support:</h5>
                  <p className="mb-4 text-justify">
                  Covering corporate governance, compliance, contract management, and more.
                  </p>
                  
                  <h5 className="mb-3 flex items-center font-semibold">
                  <div className="p-4 bg-emerald-600 opacity-90 text-white flex items-center justify-center w-12 h-12 mr-4">
                    <FontAwesomeIcon className="text-xl" icon={faGear} />
                  </div>
                  Cost-Effective Solutions:</h5>
                  <p className="mb-4 text-justify">
                  Reduce costs associated with hiring traditional in-house counsel.
                  </p>
                
                  <h5 className="mb-3 flex items-center font-semibold">
                  <div className="p-4 bg-emerald-600 opacity-90 text-white flex items-center justify-center w-12 h-12 mr-4">
                    <FontAwesomeIcon className="text-xl" icon={faBuilding} />
                  </div>
                  Scalable and Flexible:</h5>
                  <p className="mb-4 text-justify">
                  Adjust services based on your business's evolving needs.
                  </p>
            </div>
            <h1 className="uppercase text-lg font-bold my-1">Why Choose Us?</h1>
            <p className="mb-4 text-justify">
            Our team of experienced professionals ensures your legal matters are handled with the utmost care and precision, allowing you to focus on business growth while staying compliant with regulatory requirements.
            </p>
          </div>            
        </div>
      </div>
    </section>
  );
};

export default RemoteService;
